import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../../../contexts/I18nProvider";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "../../../components/ui/toggle-group";
import { setQuickFilter } from "../../../redux/slices/filterSlice";
import { selectQuickFilter } from "../../../redux/selectors/filterSelectors";

function QuickFilterPills() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const activeFilter = useSelector(selectQuickFilter);

  const QUICK_FILTERS = [
    { label: t('polyglot.filterAll'), value: 'all' },
    { label: t('polyglot.filterAudio'), value: 'audio' },
    { label: t('polyglot.filterPurchased'), value: 'purchased' },
    { label: t('polyglot.filterRecent'), value: 'recent' },
  ];

  return (
    <div className="space-y-2 polyglot-quick-filters">
      <p className="text-xs uppercase tracking-wide text-muted-foreground">
        {t('polyglot.quickFilters')}
      </p>
      <ToggleGroup
        type="single"
        value={activeFilter || "all"}
        onValueChange={(value) => {
          if (value) {
            dispatch(setQuickFilter(value));
          }
        }}
        className="flex flex-wrap justify-start gap-2 w-full max-w-full"
      >
        {QUICK_FILTERS.map((filter) => (
          <ToggleGroupItem
            key={filter.value}
            value={filter.value}
            size="sm"
            variant="secondary"
            className="rounded-full px-2 text-[11px] min-w-0 max-w-full whitespace-normal text-left"
          >
            {filter.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
}

export default QuickFilterPills;
